export const providerTypes = {
  PHYSICAL_PERSON: 'P',
  TEAM: 'E',
  INSTITUTION: 'I',
  COLLEGE: 'C',
};
